export const storageManager = {
  cloudCookieManager: null,
};
